import { useParams } from "react-router";
import { LegalEntityAuditGroupOverviewModel } from "../legalEntityAuditGroupOverview/LegalEntityAuditGroupOverview.types";
import { AuditGroupChartDataViewModel } from "@common/components/managementReport/managementReportCharts/allocationOfRiskLevelChart/AllocationOfRiskLevelChart.types";

import { useDotLegalQuery } from "@common/hooks/dotLegalReactQuery";

export function useLegalEntityAuditGroupManagementReport() {
    const { id } = useParams<{ id: string }>();

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const isPdf = Boolean(urlParams.get("isPdf"));

    const url = `/legalEntityAuditGroups/${id}/overview`;
    const { isLoading, data } = useDotLegalQuery<LegalEntityAuditGroupOverviewModel>(url);

    const chartDataUrl = `/legalEntityAuditGroups/${id}/chartData`;
    const chartDataQuery = useDotLegalQuery<AuditGroupChartDataViewModel>(chartDataUrl, {
        enabled: data !== undefined && data.scoreEnabled,
    });

    return {
        isLoading: isLoading || chartDataQuery.isLoading,
        data,
        isPdf,
        chartData: chartDataQuery.data,
    };
}
